/**
 * ルート最適化の行ごと車両指定 (#510)。
 *
 * ダイアログでドライバー行ごとに車両を選べるようにしたため、同じ車両が複数の出勤ドライバーに
 * 割り当てられる指定を検出する必要がある。画面 (実行ボタン非活性) と API (422) が同じ判定を
 * 共有するためここに置く。
 */

/** ドライバー public_id → 車両 public_id (未指定は null/undefined/空文字)。 */
export type DriverVehicleSelections = Record<string, string | null | undefined>;

/**
 * 同じ車両が 2 人以上へ指定されている車両 public_id を昇順で返す。重複が無ければ空配列。
 *
 * @param eligibleDriverIds 判定対象のドライバー (当日出勤するドライバー)。
 *   省略時は selections の全キーを対象にする。休みのドライバーの指定は最適化へ渡らないため、
 *   呼び出し側は出勤ドライバーだけを渡すこと。
 */
export function duplicateVehicleSelections(
  selections: DriverVehicleSelections,
  eligibleDriverIds?: readonly string[],
): string[] {
  const targets = eligibleDriverIds ?? Object.keys(selections);
  const countByVehicle = new Map<string, number>();
  for (const driverId of targets) {
    const vehicleId = selections[driverId];
    if (!vehicleId) continue;
    countByVehicle.set(vehicleId, (countByVehicle.get(vehicleId) ?? 0) + 1);
  }
  return [...countByVehicle.entries()]
    .filter(([, count]) => count > 1)
    .map(([vehicleId]) => vehicleId)
    .sort();
}
